import { render, staticRenderFns } from "./CallRelatedList.vue?vue&type=template&id=821f0f4a&scoped=true"
import script from "./CallRelatedList.vue?vue&type=script&lang=js"
export * from "./CallRelatedList.vue?vue&type=script&lang=js"
import style0 from "./CallRelatedList.vue?vue&type=style&index=0&id=821f0f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821f0f4a",
  null
  
)

export default component.exports